/**
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
